import { useIntl } from 'react-intl';
import { useCallback } from 'react';
import { VisitorMode } from '../../../types/form-data.types';
import { VisitorModeButton } from './visitor-mode-button';

interface VisitorModeToggleProps {
  value: VisitorMode;
  onChange: (value: VisitorMode) => void;
}

export const VisitorModeToggle = ({ value, onChange }: VisitorModeToggleProps): JSX.Element => {
  const { formatMessage } = useIntl();

  const handleSingleModeClick = useCallback(() => {
    onChange(VisitorMode.SINGLE);
  }, [onChange]);

  const handleMultipleModeClick = useCallback(() => {
    onChange(VisitorMode.MULTIPLE);
  }, [onChange]);

  return (
    <div>
      <p className="text-sm font-medium text-foreground mb-3">
        {formatMessage({
          id: 'createVisitFormV2.visitStep.visitorModeQuestion',
          defaultMessage: 'Are you inviting one visitor or multiple?',
        })}
      </p>

      <div className="grid grid-cols-2 gap-3">
        <VisitorModeButton
          isActive={value === VisitorMode.SINGLE}
          onClick={handleSingleModeClick}
          label={formatMessage({ id: 'createVisitFormV2.visitStep.oneVisitor', defaultMessage: 'One visitor' })}
        />

        <VisitorModeButton
          isActive={value === VisitorMode.MULTIPLE}
          onClick={handleMultipleModeClick}
          label={formatMessage({
            id: 'createVisitFormV2.visitStep.multipleVisitors',
            defaultMessage: 'Multiple visitors',
          })}
        />
      </div>
    </div>
  );
};
